export const actionTypes = {
  UPDATE_CONFIG_VALUES: 'CONFIG::UPDATE_CONFIG_VALUES',
};

export function createConfigAction(config) {
  return { type: actionTypes.UPDATE_CONFIG_VALUES, config };
}

export function updateSoftwareNumber(configData) {
  return async dispatch => {
    dispatch(createConfigAction({ softwareNumber: configData.softwareNumber }));
  };
}

export function createChallengesEntry(isChallengeEntry) {
  return createConfigAction({
    challengesEntry: isChallengeEntry,
  });
}

export function createSearchInitiatedFrom(path) {
  return createConfigAction({
    searchInitiatedFrom: path,
  });
}

export function resetEntryPoint() {
  return createConfigAction({
    entryPoint: null,
  });
}

export function updateConfigValues(configData) {
  return async (dispatch, getState) => {
    dispatch(createConfigAction(configData));
  };
}

export default {
  updateConfigValues,
};
